import React, { useCallback, useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CompanyList from "sections/Admin/companyList/CompanyList";
import useCompaniesStore from "store/zustand/company";
import { updateCompanyStatus } from "store/services/company.service";

const CompanyPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);
  const [activeTab, setActiveTab] = useState("company");
  const [searchQuery, setSearchQuery] = useState("");
  const {
    fetchAllCompanies,
    companiesList,
    isCompaniesListLoading,
    updateCompanyStatusLocally,
  } = useCompaniesStore();
  const onView = (company) => {
    navigate(`${company.id}`);
  };

  const handleToggleStatus = async (company) => {
    if (!company?.id) return;
    const nextStatus = !company?.is_active;
    try {
      setStatusUpdatingId(company.id);
      await updateCompanyStatus(company.id, nextStatus);
      updateCompanyStatusLocally(company.id, nextStatus);
    } catch (error) {
      console.error("Failed to update company status", error);
    } finally {
      setStatusUpdatingId(null);
    }
  };

  const loadCompanies = useCallback(() => {
    const params = {
      page: 1,
      limit: 10,
      isPaginated: "false",
      ...(searchQuery.trim() ? { search: searchQuery.trim() } : {}),
    };
    if (activeTab === "company") {
      fetchAllCompanies({ ...params, is_supplier: false });
    } else {
      fetchAllCompanies({ ...params, is_supplier: true });
    }
  }, [activeTab, fetchAllCompanies, searchQuery]);

  useEffect(() => {
    const timer = setTimeout(loadCompanies, searchQuery ? 300 : 0);
    return () => clearTimeout(timer);
  }, [loadCompanies, searchQuery]);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };
  const isCompanyTab = activeTab === "company";
  const listData = isCompanyTab ? companiesList : companiesList;

  const listTitle = isCompanyTab
    ? t("companyList.company")
    : t("nav.Supplier");

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label={t("companyList.tabsLabel")}
        sx={{ mb: 3 }}
      >
        <Tab label={t("companyList.company")} value="company" />
        <Tab label={t("companyList.supplier")} value="supplier" />
      </Tabs>

      <CompanyList
        title={listTitle}
        onView={onView}
        companies={listData}
        loading={isCompaniesListLoading}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onToggleStatus={isCompanyTab ? handleToggleStatus : handleToggleStatus}
        statusUpdatingId={isCompanyTab ? statusUpdatingId : statusUpdatingId}
        onPlanChanged={loadCompanies}
      />
    </Box>
  );
};

export default CompanyPage;
